import styled from '@emotion/styled';
import React from 'react';

type CellProps = {
  children: React.ReactNode;
  isHighlighted?: boolean;
};

const Cell = ({ children, isHighlighted = false }: CellProps) => {
  return <CellContainer isHighlighted={isHighlighted}>{children}</CellContainer>;
};

export default Cell;

const CellContainer = styled.div<{ isHighlighted: boolean }>`
  background: ${({ theme, isHighlighted }) => (isHighlighted ? theme.customOverrides.Calendar.highlightPrimary : theme.palette.background.paper)};
  padding: 1rem;
  aspect-ratio: 1 / 1;
  max-width: 100%;

  /* first cell in the last row */
  &:nth-of-type(7n + 1):nth-last-of-type(-n + 7) {
    border-bottom-left-radius: ${({ theme }) => `${theme.shape.borderRadius * 2.4}px`};
  }

  /* last cell in the last row */
  &:last-child {
    border-bottom-right-radius: ${({ theme }) => `${theme.shape.borderRadius * 2.4}px`};
  }
`;
